import i18n from '../i18n';

/** Muss zu UploadLimits.MaxFileSizeBytes im Backend passen (Backend/BreedersDiary.API/Services/UploadLimits.cs). */
export const MAX_UPLOAD_SIZE_MB = 25;
const MAX_UPLOAD_SIZE_BYTES = MAX_UPLOAD_SIZE_MB * 1024 * 1024;

/** Wird schon beim Auswaehlen geprueft, damit eine zu grosse Datei nicht erst komplett hochgeladen und dann abgewiesen wird. */
export const exceedsUploadLimit = (file: Blob) => file.size > MAX_UPLOAD_SIZE_BYTES;

export const fileTooLargeMessage = (file: File) =>
  i18n.t('common:errors.fileTooLarge', { name: file.name, max: MAX_UPLOAD_SIZE_MB });
